<template>
  <router-view />
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// 创建一个响应式变量来存储鼠标是否在移动
const mouseActive = ref(false);
// 定义一个指定时间
const intervalTimes = ref(1800)

// 定义一个当前时间记录 与开始监听 时的 时差 累计数
const timeDiff = ref(0)

// 定义一个计时器 增加累计数
const interval = ref(null)

// 定义一个处理鼠标移动事件的方法
const handleMouseMove = () => {
  mouseActive.value = true;
  // console.info('移动中.....')
  // 使用 setTimeout 处理鼠标停止移动的逻辑
  clearTimeout(mouseTimeout.value);
  mouseTimeout.value = setTimeout(() => {
    mouseActive.value = false;
  }, 1000); // 1秒后认为鼠标已停止移动
};

// 创建一个响应式变量来存储定时器 ID
const mouseTimeout = ref(null);

// 在组件挂载时添加事件监听器
onMounted(() => {
  // window.addEventListener('mousemove', handleMouseMove);
  // interval.value = setInterval(() => {
  //   timeDiff.value++
  //   //累计数达到 指定时间时重置并  执行其它方法事件
  //   if (timeDiff.value >= intervalTimes.value) {
  //     // 达到指定检测范围 并且此时鼠标有移动时  刷新 token时效
  //     if (mouseActive.value) {
  //       timeDiff.value = 0
  //       console.info('移动中.....并且达到指定范围', timeDiff.value)
  //     }
  //     // 如果达到指定时间 的两倍 即 1小时（默认） 鼠标未进行移动 则自动退出登录 （登录token失效）
  //     if (timeDiff.value >= 2 * interval.value) {
  //       console.info('停止移动中.....超过1小时', timeDiff.value)
  //     }
  //   }
  //   //每隔30秒打印日志
  //   if (timeDiff.value % 30 === 0 && !mouseActive.value) {
  //     console.info('停止移动中.....', timeDiff.value)
  //   }
  // }, 1000)

});

// 在组件卸载时移除事件监听器
onUnmounted(() => {
  // window.removeEventListener('mousemove', handleMouseMove);
  // clearTimeout(mouseTimeout.value); // 清除定时器
  // clearInterval(interval.value) //清除计时器
});


</script>
<style>
html,
body,
#app {
  height: 100%;
}

.app-container {
  padding: 20px
}

/* 加载进度条颜色 */
/* #nprogress .bar {
  background: rgb(71, 221, 34) !important;

} */

/* 加载icon 颜色 */
/* #nprogress .spinner-icon {
  border-top-color: rgb(93, 221, 34) !important;
  border-left-color: rgb(71, 221, 34) !important;
} */
</style>
